import { Toggle } from '../NarusMaterial/Toggle'

import { makeAutobindedInput } from './FormBuilder'

const Toggle_ = ({ onChange, label, ...rest }) => (
  <Toggle
    label={label}
    onChange={checked => onChange && onChange(checked)}
    {...rest}
  />
)

export const ToggleInput = makeAutobindedInput(Toggle_)
